import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./assistantMarkdown.css";

function AssistantMarkdown({ text, className = "" }) {
   if (!text) return null;

   return (
      <div className={`assistant-markdown ${className}`.trim()}>
         <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
      </div>
   );
}

export default AssistantMarkdown;
